import React, {useCallback} from 'react';

import {Role} from 'src/openapi/models/Role';
import {UserRoles} from 'src/openapi/models/UserRoles';

import {CheckBox} from '@pb/kit-component-checkbox';

type Props = {
    role: Role,
    userRoles: UserRoles,
    onRoleChangeHandle: (email: string, role: string, checked: boolean) => void,
};

export const UserRoleCheckBox = ({role, userRoles, onRoleChangeHandle}: Props) => {

    const onCheckBoxChange = useCallback((
        changeData: {
            event: React.ChangeEvent<HTMLInputElement>,
            name: string,
        },
    ) => {
        const value = changeData.event.target.value;
        const checked = changeData.event.target.checked;

        onRoleChangeHandle(userRoles.email, value, checked);
    }, [onRoleChangeHandle, userRoles.email]);

    return (
        <CheckBox
            value={role}
            checked={userRoles.roles.includes(role)}
            onCheckBoxChange={onCheckBoxChange}
        />
    );
};
